// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HYNx","newExpiryDate":"styles_newExpiryDate__2Dxmq","footer":"styles_footer__3vFBg"};